/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-useless-constructor */
import { Link, useHistory } from 'react-router-dom';
import { GridColumn, Grid } from '@progress/kendo-react-grid';
import { withState } from '../../../../components/common/grid/WrappedGrid';
import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import { API_URL } from '../../../../utils/constants';
import createIcon from '../../../../static/img/createIcon.svg';
import GridWrapper from '~/src/components/common/GridWrapper';

const logo = new URL('../../../../static/img/SVG/PopUpIcon.svg', import.meta.url);

export default function GenericProductsList(): JSX.Element {
  const url = `${API_URL}/products/generics/get`;
  const history = useHistory();
  const StatefullGrid = withState(Grid, url);

  const brandCell = (p) => {
    return <td>{p?.dataItem?.brand?.name}</td>;
  };

  const categoryCell = (p) => {
    const catNames = p?.dataItem?.categories.map((cat) => cat.category.name);
    const stringNames = catNames.join(', ');
    
    return <td>{stringNames}</td>;
  };

  const hsCodeCell = (p) => {
    return (
      <td>
        {p?.dataItem?.hsCode?.code}
        <br />
        {p?.dataItem?.hsCode?.nameEn}
      </td>
    );
  };

  const productNameCell = (row, ref) => {
    const { dataItem } = row;

    return (
      <td>
        <Link to={`/products/edit/${dataItem.id}`}>{dataItem.name}</Link>{' '}
        <Link to={`/products/edit/${dataItem.id}`} target="_blank">
          <img src={logo} alt="logo" />
        </Link>
      </td>
    );
  };

  return (
    <WhitePad isFluid>
      <TitleComponent
        title="Products"
        titleRight="Create"
        onRightHandler={(): void => history.push('/products/create')}
        iconRight={createIcon}
        titleLeft="Back"
        onLeftHandler={(): void => history.goBack()}
      />
      <GridWrapper>
        <StatefullGrid>
          <GridColumn field="name" title="Name" cell={productNameCell} />
          <GridColumn field="gtin" title="Gtin" />
          <GridColumn field="price" title="Price" />
          <GridColumn field="brandId" title="Brand" cell={brandCell} />
          <GridColumn field="category" title="Categories" cell={categoryCell} />
          <GridColumn field="hscode" title="HS Code" cell={hsCodeCell} />
        </StatefullGrid>
      </GridWrapper>
    </WhitePad>
  );
}
